<i [ngClass]="icon" [ngStyle]="{'font-size': '20px'}"></i>
<span class="caption-xs" [ngClass]="{'text-primary-text-on-container': primaryTextColor }">{{ labelKey | translate }}</span>
